import React from 'react';
import { useCardContext } from 'contexts/CardContext'; // Adjust the import path as needed

const ClearImagesButton = () => {
  const { clearImages } = useCardContext();

  return (
    <button onClick={clearImages}>
      Clear Images
    </button>
  );
};

export default ClearImagesButton;